import { AuditorForm } from './components';
import {
  BasicInfoSupplier,
  ActivityAreaForm,
  BankForm,
  DocumentsEquipmentSupplier,
  DocumentsSupplier,
  TermsSupplier,
  UpdateDocumentsEquipmentSupplier,
  } from '../mainFormSupplier/components';
  import { tabs } from '../mainFormSupplier/components/basicInfoSupplier/tabs';
  // import { getLocalString, localNames } from "utils/localisation.service";
import { isEmpty, isNil } from 'lodash';

export const stepsAuditor = ({ isDirectSupplier, isIndirectSupplier, activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment }) =>  {
  return [
 {
    name: 'BASICFORMSUPPLIER',
    label: 'Βασικά Στοιχεία Προμηθευτή',
    Component: BasicInfoSupplier,
    tabsComponent : tabs({ isDirectSupplier, isIndirectSupplier }),
    subtabs: true,
    id: 0,
  },
  {
    name: 'AREAFORM',
    label: 'Περιοχή Δραστηριότητας',
    Component: ActivityAreaForm,
    id: 1,
    hidden: !isDirectSupplier,
  },
  {
    name: 'BANKFORM',
    label: 'Στοιχεία Πιστωτικού Ιδρύματος',
    Component: BankForm,
    id: 2,
    hidden: !isDirectSupplier,
  },
  {
    name: 'EQUIPMENTDOCUMENT',
    label: 'Εξοπλισμός',
    Component: DocumentsEquipmentSupplier,
    id: 3,
    hidden: !isIndirectSupplier,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: DocumentsSupplier,
    id: 4,
    hidden: !isDirectSupplier,
  },
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: TermsSupplier,
    id: 5,
  },
  {
    name: 'EVALUATIONFORM',
    label: 'Αξιολόγηση Αίτησης',
    Component: AuditorForm,
    id: 6,
  },
   {
    name: 'UPDATEEQUIPMENTDOCUMENT',
    label: 'Ανανέωση Εξοπλισμού',
    Component: UpdateDocumentsEquipmentSupplier,
    id: 8,
    hidden: !(activeTaskName === "task.name.accepted"),
  },
].filter(item => !item?.hidden)
};